<template>
  <a-card title="创作类型">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="Style ID" v-model:value="formSearch.style_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="Style Name" v-model:value="formSearch.style_name" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="Style Title" v-model:value="formSearch.style_title" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="Type ID" v-model:value="formSearch.typeid" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="category_id" v-model:value="formSearch.category_id" />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button
            type="primary"
            @click="openDia = !openDia"
          >
          新建类型
          </a-button>
        </a-form-item> -->
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
     
      <template #style_image="{ record }">
        <img :src="record.style_image" width="100" />
      </template>
      <template #sorted="{ record }">
        <a-input-group compact>
          <a-input v-model:value="record.sorted"  style="width: 80px;" />
          <a-button type="primary" @click="handleUpdate(record)"  >设置</a-button>
        </a-input-group>
      </template>
     
    
      <template #is_delete="{ record }">
        <a-tag v-if="record.is_delete == 1" color="gray">已删除</a-tag>
        <a-tag v-if="record.is_delete == 0" color="green">正常</a-tag>

      </template>
      <template #style_name="{ record }">
        <div>name: {{ record.style_name }}</div>
        <div>title: {{ record.style_title }}</div>
      </template>
      <template #about_date="{ record }">
        <div>创建时间: {{ record.created_at }}</div>
        <div>修改时间: {{ record.updated_at }}</div>
      </template>
      <template #action="{ record }">
       <a-space>
        <!-- <a-button v-if="record.is_delete == 0"   warn @click="handleUpdate(record)"  >编辑</a-button> -->
        <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleDelete(record)"
        >
          <a-button v-if="record.is_delete == 0"   danger   >删除</a-button>
        </a-popconfirm>
        
       </a-space>
      </template>
      </a-table>
  </a-card>
  <a-modal v-model:visible="openDia" :title="'新建技巧'" @cancel="resetForm" @ok="handleConfirm" :confirm-loading="confirmLoading">
    <a-form :model="formAdd" style="margin: 10px auto;" :rules="rules" ref="formRef" >
        <a-form-item label="标题" name="title">
          <a-input placeholder="标题" v-model:value="formAdd.title" />
        </a-form-item>
        <a-form-item  label="风格(工具)"  name="style_id">
          <a-select
            v-model:value="formAdd.style_id"
            :options="styleIDOptions"
            placeholder="产品 ID"
          />
        </a-form-item>
        <a-form-item label="原图" name="origin_image_url">
          <Upload v-model:imageUrl="formAdd.origin_image_url"  />
        </a-form-item>
        <a-form-item label="封面" name="cover_url">
          <Upload v-model:imageUrl="formAdd.cover_url"  />
        </a-form-item>
        
        <a-form-item label="操作" name="action_image_url">
          <div v-for="(item, index) in formAdd.action_image_urls " :key="index">
            <div style="display: flex; flex-direction: row; ">
              <Upload  v-model:imageUrl="formAdd.action_image_urls[index]"   />
              <a-button danger @click="delete(formAdd.action_image_urls[index])">删除</a-button>
            </div>
          </div>
          <a-button type="primary" @click="action_image_index ++; formAdd.action_image_urls[action_image_index]=''">增加操作图</a-button>

        </a-form-item>
      </a-form>
  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import store from '@/store'
import Upload from '../components/Upload.vue'


export default defineComponent({
  components: {
    Upload,
    SearchOutlined
  },
  data(){
    return {
      styleIDOptions: [],
      styleNames :{},
      loading: false,
      openDia: false,
      dataSource: [],
      action_image_index: 0,
      formAdd: {
        id: 0,
        title: '',
        style_id: '0',
        cover_url : '',
        action_image_urls: {},
        origin_image_url: '',
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',

       formSearch: {
        style_id: '',
        style_title: '',
        style_name:'',
        category_id: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  computed:{
    username : () => {
      if (store) {
        return `${store.state.user.nickname}-${store.state.user.user_id}`
      }
      
    },
  },
  methods: {
    
    async handleConfirm(){
      if (this.formAdd.id) {
        const rsp = await request.put(`/api/creation/styles/${this.formAdd.id}`, {
          ...this.formAdd,
          action_image_urls: Object.values(this.formAdd.action_image_urls)
        })
      } else {
        const rsp = await request.post('/api/creation/styles', {
          ...this.formAdd,
          action_image_urls: Object.values(this.formAdd.action_image_urls)
        })
      }
     
      this.openDia = !this.openDia
      this.loading = false
      this.handleTableChange()
    },
    async handleUpdate(record){
      let payload = record
      payload['sorted'] = + payload['sorted']
      const rsp = await request.put(`/api/creation/styles/${record.id}`, {
        ...payload,
      })
      this.handleTableChange( this.pagination)
    },
    async handleDelete(record){
      const rsp = await request.delete(`/api/creation/styles/${record.id}`, { })
      this.handleTableChange( this.pagination)
    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/creation/styles/search', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'style_id',
          dataIndex: 'style_id',
          key: 'style_id',
        

        },
        {
          title: '类型名',
          dataIndex: 'style_name',
          key: 'style_name',
          slots: { customRender: 'style_name' },
        },
        {
          title: '封面图',
          dataIndex: 'style_image',
          key: 'style_image',
          slots: { customRender: 'style_image' },
        },
        {
          title: '排序',
          dataIndex: 'sorted',
          key: 'sorted',
          slots: { customRender: 'sorted' },
        },
        {
          title: 'typeid',
          dataIndex: 'typeid',
          key: 'typeid',
        },
        {
          title: 'category_id',
          dataIndex: 'category_id',
          key: 'category_id',
        },
        {
          title: 'category_name',
          dataIndex: 'category_name',
          key: 'category_name',
        },
        {
          title: '状态',
          dataIndex: 'is_delete',
          key: 'is_delete',
          slots: { customRender: 'is_delete' },
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'about_date' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>